import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ParcelInTrip } from '../apply-transit-dialog/apply-transit-dialog.component';

export interface ParcelsInTripDialogData {
    parcelsInTrip: ParcelInTrip[];
}

@Component({
    selector: 'app-parcels-in-trip-dialog',
    standalone: true,
    templateUrl: './parcels-in-trip-dialog.component.html',
    styleUrls: ['../select-new-tour-dialog/select-new-tour-dialog.component.css', './parcels-in-trip-dialog.component.css'],
    imports: [
        CommonModule,
        MatDialogModule
    ]
})
export class ParcelsInTripDialogComponent {
    constructor(
        private dialogRef: MatDialogRef<ParcelsInTripDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ParcelsInTripDialogData
    ) {
    }

    close(): void {
        this.dialogRef.close();
    }
}
